import request from '@/utils/request'

export function getList (entity, filters = {}, pagination = {}) {
  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    }
  })
}

export function getCount (entity, filters = {}) {
  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 1 })
    }
  }).then(ret => ret.tot)
}



export function getDetail (entity, item) {
  return request({
    url: '/' + entity + (item && item.id ? '/' + item.id  : ''),
    method: 'get'
  })
}

export function get (url) {
  return request({
    url,
    method: 'get',
  })
}

export function put (entity, id, data) {
  const method = 'put'
  const url = '/' + entity + '/' + id
  return request({
    url,
    method,
    data
  })
}

export function upsert (entity, data, id) {
  let method = 'post'
  let url = '/' + entity
  if (id) {
    method = 'put'
    url = '/' + entity + '/' + id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (entity, item) {
  return request({
    url: '/' + entity + '/' + item.id,
    method: 'delete'
  })
}
